import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ADMIN_EMAIL = 'sercantoprak3@gmail.com';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const [isChecking, setIsChecking] = useState(true);

  // Kullanıcı verisi geldiğinde veya loading bittiğinde kontrolü tamamla
  useEffect(() => {
    if (!loading) {
      // Supabase'in oturumu tam oturtması için ufak bir güvenlik payı (500ms)
      const timer = setTimeout(() => {
        setIsChecking(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  // 1. Yükleniyorsa veya bekleme süresindeysek Spinner göster
  if (loading || isChecking) {
    return (
      <div className="min-h-screen bg-stone-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-amber-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-stone-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  // 2. Kontrol bitti, hala kullanıcı yoksa -> Login'e at
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. Kullanıcı var ama mail tutmuyor -> Ana sayfaya at
  if (user.email !== ADMIN_EMAIL) {
    return <Navigate to="/" replace />;
  }

  // 4. Her şey yolunda -> Kapıyı aç
  return <>{children}</>;
}

export default AdminGuard;
